import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]

import { getCurrentInstance, nextTick, onMounted, onUnmounted, onUpdated, ref } from "vue";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";
import DsModalDialog from "../modal-dialog/ds-modal-dialog.vue";
import DsModalVideoGdprOverlay from "./ds-modal-video-gdpr-overlay.vue";
import { DsModalVideoProps } from "./ds-modal-video-props";
import { useDsModalVideoTools } from "./use-ds-modal-video-tools";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { debounce } from "@sazka/utils/debounce";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-modal-video',
  props: {
    videoCodeOrUrl: {},
    modelValue: { type: Boolean },
    isInStorybook: { type: Boolean, default: false },
    theme: { default: "light" },
    cssClass: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const app = getCurrentInstance();
const overlayRef = ref<InstanceType<typeof DsModalVideoGdprOverlay> | null>(null);
const dialogRef = ref<InstanceType<typeof DsModalDialog> | null>(null);
const scrollHeight = ref(0);
const isModalVisible = ref(false);
const canShowVideo = ref(false);
const { embedVideoUrl } = useDsModalVideoTools(props.videoCodeOrUrl);
const { thirdPartyConsented } = useWecomaIntegration();

const checkForConsent = async () => {
    const consented = await thirdPartyConsented();
    canShowVideo.value = consented;
};

checkForConsent();

const handleModalClosed = () => {
    nextTick(() => {
        app.appContext.app.unmount();
    });
};

onMounted(() => {
    isModalVisible.value = true;
    eventBus.on(GlobalEvents.ConsentsChanged, checkForConsent);
});

function setMinHeight() {
    if (!dialogRef.value?.dialogBodyRef) return;

    dialogRef.value?.dialogBodyRef?.style.setProperty(
        "min-height",
        `calc(${scrollHeight.value}px + calc(var(--sp-dynamic-300, 24px) * 2))`
    );
}

function handleResize() {
    scrollHeight.value = overlayRef.value?.gdprOverlayContent.scrollHeight;
    setMinHeight();
}

const handleResizeDebounced = debounce(handleResize, 50);

onUpdated(() => {
    scrollHeight.value = overlayRef.value?.gdprOverlayContent.scrollHeight;
    setMinHeight();
});

window.addEventListener("resize", handleResizeDebounced);

onUnmounted(() => {
    eventBus.off(GlobalEvents.ConsentsChanged, checkForConsent);
    window.removeEventListener("resize", handleResizeDebounced);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    cssClass: ['ds-modal-dialog--video', canShowVideo.value ? 'ds-modal-dialog--gdpr-consented' : ''],
    modelValue: isModalVisible.value,
    modalPosition: "center",
    animate: true,
    theme: _ctx.theme,
    "onUpdate:modelValue": handleModalClosed,
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    content: _withCtx(() => [
      (canShowVideo.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: _unref(embedVideoUrl),
            title: "Video",
            class: "ds-modal-dialog__iframe",
            allowfullscreen: "",
            allow: "autoplay; encrypted-media",
            loading: "lazy"
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(DsModalVideoGdprOverlay, {
            key: 1,
            videoUrl: _unref(embedVideoUrl),
            ref_key: "overlayRef",
            ref: overlayRef
          }, null, 8, ["videoUrl"]))
    ]),
    _: 1
  }, 8, ["cssClass", "modelValue", "theme"]))
}
}

})